import { CaseDocumentAdmin } from "pwapi";

import {
  ADMIN_CASE_DOCUMENT_FAILURE,
  ADMIN_CASE_DOCUMENT_REQUEST,
  ADMIN_CASE_DOCUMENT_SUCCESS,
  ADMIN_DELETE_CASE_DOCUMENT_SUCCESS,
  ADMIN_SET_CASE_DOCUMENT,
  ADMIN_UPDATE_CASE_DOCUMENT_FAILURE,
  ADMIN_UPDATE_CASE_DOCUMENT_REQUEST,
  ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS,
} from "../../actions/adminConstants";

export interface AdminDocumentState {
  document: CaseDocumentAdmin | null;
  isLoading: boolean;
}

export const initialState: AdminDocumentState = {
  document: null,
  isLoading: false,
};

const reducer = (
  state: AdminDocumentState = initialState,
  action: any
): AdminDocumentState => {
  switch (action.type) {
    case ADMIN_DELETE_CASE_DOCUMENT_SUCCESS:
    case ADMIN_UPDATE_CASE_DOCUMENT_SUCCESS:
      return {
        document: null,
        isLoading: false,
      };
    case ADMIN_UPDATE_CASE_DOCUMENT_REQUEST:
    case ADMIN_CASE_DOCUMENT_REQUEST:
      return {
        document: null,
        isLoading: true,
      };
    case ADMIN_UPDATE_CASE_DOCUMENT_FAILURE:
    case ADMIN_CASE_DOCUMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case ADMIN_SET_CASE_DOCUMENT:
    case ADMIN_CASE_DOCUMENT_SUCCESS:
      return {
        document: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
